var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_ball",class:_vm.mark},[_c('div',{staticClass:"se_ball",class:_vm.mark},[_c('div',{staticClass:"tr_ball",class:_vm.mark},[_c('div',{staticClass:"la_ball",class:_vm.mark},[_c('div',{staticClass:"fo_ball",class:_vm.mark},[_c('p',[_vm._v(_vm._s(this.number))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }